import React, { useEffect, useState } from "react";
import { useNavigate, useSearchParams } from "react-router-dom";
import bgImage from "../../assets/images/bg-img.jpg";
import axios from "axios";

const CandidateJobsStatus = ({ candidateId }) => {
  const [jobs, setJobs] = useState([]);
  const [loading, setLoading] = useState(true);
  const navigate = useNavigate();
  const [searchParams] = useSearchParams();
  const candidateID = searchParams.get("candidate_id"); // Get the 'Candidate id' from the URl;

  useEffect(() => {
    const fetchStatus = async () => {
      try {
        // const response = await fetch(
        //   `${process.env.REACT_APP_API_KEY}/fetch_candidate_interview_status?candidate_id=${candidateID}`
        // );
        const response = await fetch(
          `${process.env.REACT_APP_API_KEY}/fetch_candidate_interview_status?candidate_id=${candidateID}`,
          {
            method: "GET",
            headers: {
              "Cache-Control": "no-cache",
              Pragma: "no-cache",
              Expires: "0",
            },
          }
        );
        const data = await response.json();
        setJobs(data.candidate_applied_jobs || []);
      } catch (error) {
        console.error("Error fetching interview status:", error);
        setJobs([]);
      } finally {
        setLoading(false);
      }
    };

    fetchStatus();
  }, [candidateId]);

  const handleRedirect = (status, link, jobId) => {
    const url = new URL(link);
    const candidateID = url.searchParams.get("candidate_id");

    if (status === "Pending") {
      navigate(`/ai-interview?id=${jobId}&candidate_id=${candidateID}`);
    } else if (status === "Completed") {
      navigate(`/candidate-dashboard?id=${jobId}&candidate_id=${candidateID}`);
    }
  };

  // const handleDownloadReport = async (id) => {
  //   try {
  //     const response = await axios.get(
  //       `${process.env.REACT_APP_API_KEY}/download_candidate_zip?jd_id=${id}&candidate_id=${candidateID}`
  //     );

  //     const fileUrl = response.data.link;
  //     const link = document.createElement("a");
  //     link.href = fileUrl;
  //     link.setAttribute("download", `interview_report_${id}.zip`);
  //     document.body.appendChild(link);
  //     link.click();
  //     link.remove();
  //   } catch (error) {
  //     console.error("Error downloading report:", error);
  //     alert("❌ Failed to download report. Please try again later.");
  //   }
  // };

  const handleDownloadReport = async (id) => {
    try {
      const response = await axios.get(
        `${process.env.REACT_APP_API_KEY}/download_candidate_zip?jd_id=${id}&candidate_id=${candidateID}`,
        {
          responseType: "blob", // important for binary files,
          headers: {
            "Cache-Control": "no-cache",
            Pragma: "no-cache",
            Expires: "0",
          },
        }
      );

      // Create a URL from the blob
      const url = window.URL.createObjectURL(new Blob([response.data]));

      // Create a temporary anchor element to trigger download
      const link = document.createElement("a");
      link.href = url;
      link.setAttribute("download", `interview_report_${id}.zip`); // default file name
      document.body.appendChild(link);
      link.click();
      document.body.removeChild(link);

      // Clean up URL object
      window.URL.revokeObjectURL(url);
    } catch (error) {
      console.error("Error downloading report:", error);
      alert("❌ Failed to download report. Please try again later.");
    }
  };

  return (
    <div
      className="w-full pt-10 p-6  min-h-[calc(100vh-96px)]"
      style={{
        backgroundImage: `url(${bgImage})`,
        backgroundRepeat: "no-repeat",
        backgroundSize: "cover",
        backgroundPosition: "center",
      }}
    >
      <div>
        <h2 className="text-2xl font-bold text-white mb-6">Applied Jobs :</h2>

        {loading ? (
          <p className="text-white">Loading...</p>
        ) : Array.isArray(jobs) && jobs.length > 0 ? (
          <div className="overflow-x-auto">
            <table className="w-full table-auto  bg-white  rounded-xl  p-4 shadow-lg">
              <thead className="text-lg font-semibold text-blue-800 mb-3 text-left">
                <tr className="text-lg font-semibold text-blue-800 mb-3">
                  <th className="p-3 ">Job Name</th>
                  <th className="p-3">Job ID</th>
                  <th className="p-3">Status</th>
                  <th className="p-3">Action</th>
                </tr>
              </thead>
              <tbody>
                {jobs.map((job, index) => (
                  <tr
                    key={index}
                    className="border-t font-medium cursor-pointer text-gray-700 transition duration-150"
                  >
                    <td className="p-3">{job.job_name}</td>
                    <td className="p-3">{job.job_id}</td>
                    <td className="p-3">
                      <span
                        className={`font-medium ${
                          job.interview_status === "Completed"
                            ? "text-green-600"
                            : job.interview_status === "Pending"
                            ? "text-red-600"
                            : "text-yellow-600"
                        }`}
                      >
                        {job.interview_status}
                      </span>
                    </td>
                    <td className="p-3">
                      {job.interview_status === "Ongoing" ? (
                        <span className="text-yellow-600 font-medium">
                          Ongoing
                        </span>
                      ) : (
                        // <button
                        //   className={`px-4 py-1.5  transition text-white rounded-lg ${
                        //     job.interview_status === "Completed"
                        //       ? "bg-green-600 hover:bg-green-700"
                        //       : "bg-blue-600 hover:bg-blue-700"
                        //   }`}
                        //   onClick={() =>
                        //     handleRedirect(
                        //       job.interview_status,
                        //       job.interview_link,
                        //       job.job_id
                        //     )
                        //   }
                        // >
                        //   {job.interview_status === "Completed"
                        //     ? "View Dashboard"
                        //     : "Start Interview"}
                        // </button>
                        <div className="flex gap-2">
                          <button
                            className={`px-4 py-1.5 transition text-white rounded-lg ${
                              job.interview_status === "Completed"
                                ? "bg-green-600 hover:bg-green-700"
                                : "bg-blue-600 hover:bg-blue-700"
                            }`}
                            onClick={() =>
                              handleRedirect(
                                job.interview_status,
                                job.interview_link,
                                job.job_id
                              )
                            }
                          >
                            {job.interview_status === "Completed"
                              ? "View Dashboard"
                              : "Start Interview"}
                          </button>

                          {job.interview_status === "Completed" && (
                            <button
                              onClick={() => handleDownloadReport(job.job_id)}
                              className="px-4 py-1.5 bg-indigo-600 hover:bg-indigo-700 text-white rounded-lg transition"
                            >
                              Download Report
                            </button>
                          )}
                        </div>
                      )}
                    </td>
                  </tr>
                ))}
              </tbody>
            </table>
          </div>
        ) : (
          <p className="text-gray-600">No applied jobs found.</p>
        )}
      </div>
    </div>
  );
};

export default CandidateJobsStatus;
